module.exports = __webpack_public_path__ + "img/deutsche-telekom-logo.8e2307c4.svg";